import { reactive } from 'vue'

/** A waiting app version (set by the service-worker registration, shown by UpdatePrompt). */
export const pwaUpdate = reactive({
  /** a newer version is installed and waiting */
  ready: false,
  /** activate the waiting version and reload */
  apply: () => undefined as void | Promise<void>,
})
